import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export interface RegionCargandoProps extends HTMLAttributes<HTMLDivElement> {
  /** Texto para lectores de pantalla · default «Cargando…». */
  etiqueta?: string;
}

/**
 * Contenedor accesible común a todos los skeletons: anuncia la carga
 * (`role="status"` + `aria-busy`) con un texto sr-only. Las barras animadas
 * respetan `prefers-reduced-motion` por la regla global de `globals.css`.
 */
export function RegionCargando({ etiqueta = "Cargando…", className, children, ...props }: RegionCargandoProps) {
  return (
    <div role="status" aria-busy="true" className={cn(className)} {...props}>
      <span className="sr-only">{etiqueta}</span>
      {children}
    </div>
  );
}
